// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import VueSweetAlert from 'vue-sweetalert'
import VueSession from 'vue-session'
import VueMask from 'v-mask'
import 'bootstrap/dist/css/bootstrap.css'
import vueXlsxTable from 'vue-xlsx-table'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import 'vue2-timepicker/dist/VueTimepicker.css'
// import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'

Vue.config.productionTip = false
Vue.use(VueSweetAlert)
// Vue.use(VueCharts)
Vue.use(VueSession)
Vue.use(VueMask)
Vue.use(vueXlsxTable, {
  rABS: false
})

// Sentry.init({
//   Vue,
//   dsn: process.env.VUE_APP_SENTRY_DNS,
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: [process.env.VUE_APP_SENTRY_TRACING_ORIGIN, /^\//]
//     })
//   ],
//   tracesSampleRate: 1.0
// })

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API,
    libraries: 'places' // This is required if you use the Autocomplete plugin
  },
  installComponents: true
})

Vue.prototype.$liff_id_login = process.env.VUE_APP_LIFF_ID_LOGIN
Vue.prototype.$liff_id_login_emp = process.env.VUE_APP_LIFF_ID_LOGIN_EMP
Vue.prototype.$liff_id_login_emp_check = process.env.VUE_APP_LIFF_ID_LOGIN_EMP_CHEK
Vue.prototype.$liff_info = process.env.VUE_APP_LIFF_ID_INFO
Vue.prototype.$liff_checkinout = process.env.VUE_APP_LIFF_ID_CHECKINOUT
Vue.prototype.$liff_risk_assessment = process.env.VUE_APP_LIFF_ID_RISK_ASSESSMENT
Vue.prototype.$liff_leave = process.env.VUE_APP_LIFF_ID_LEAVE
Vue.prototype.$liff_shift_tranfer = process.env.VUE_APP_LIFF_ID_SHIFT_TRANFER
Vue.prototype.$liff_news = process.env.VUE_APP_LIFF_ID_NEWS
Vue.prototype.$liff = window.liff
Vue.config.productionTip = false
Vue.mixin({
  data: function () {
    return {
      globalVar: 'global',
      DNS_IP: '',
      PK: '', // Primary Key
      ApplicationKey: '', // Token
      main_profile: {
        // userLineuserId: 'U811691be65996a393d790c3c7a66ac1a', // พี่อ้อย
        // userLineuserId: 'U9f6cc3ade594e9f35d0c21510a48931e', // ไขตรี
        // userLineuserId: 'Ue5f7e8597b17161176f32b3056f55790', // ตั้ก
        // userLineuserId: 'Ud9a20671a343251bd1b31eaf397ef49b', // จันทนา
        // userLineuserId: 'U0229deb1f36b4c89f41f5181872a9492', // พี่เจน
        // userLineuserId: 'U3548b1fbe07ed202375b708b653cc225', // ชวัลวิทย์
        // userLineuserId: 'U82c262c0d5f644d3b8f16c71c58d32b9', // นายธนพล แซ่ตั้ง
        // userLineuserId: 'Ue6cc463f055b0b888ff1c5d1e572afed',
        userLineuserId: process.env.VUE_APP_LINE_USER_ID, // เทพนที
        pictureUrl: 'https://profile.line-scdn.net/0hI98EfztKFhYFPAIISNBpQTl5GHtyEhBefVoNdiA_SSMtWFdIbV0KIiU9HCApCFUSbVxZJSZpSyQh',
        token: 'TU2c2a6a5eaf2a8f410404714bc8d05e035368ceafd65c028636a6e0a1558f255f9077bbce0fa8fe0feca559406f365a68',
        accesstoken: 'eyJhbGciOiJIUzI1NiJ9.A_8kHXk97L92XPZp6VSQrtfnwb_KKef9ckvUwhrvAmBwLqKOJ1GIr2DU-Jn-L31FaGRiVQiYGmyluQz5dSg1jZ_H1LdZ4Z2LV6hIqcaFm0YUudjRoM60m_dEgN6P5rn0SvGvsH6HlZuTAhXEWIK3d8yr05vGM9DfsYgAd0xFz4w.mKb8ZZURDOj-yiH3-JLbNHPeWRaoZiqw0vlfCP5kKt4'
      },
      dataItem: [],
      dataItemImport: [],
      export_data: [],
      searchAll: '',
      dataReady: true
    }
  },
  async mounted () {
    this.DNS_IP = process.env.VUE_APP_API
    this.DNS_IP_UPLOAD = process.env.VUE_APP_API_UPLOAD
    console.log(this.DNS_IP, this.DNS_IP_UPLOAD)
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    format_date_1 (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    // YYYY-MM-DD
    momenDate_1 (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    getDateTh () {
      let date = new Date()
      date.setDate(date.getDate())
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var dt = date.getDate()

      if (dt < 10) {
        dt = '0' + dt
      }
      if (month < 10) {
        month = '0' + month
      }
      var now = year + '-' + month + '-' + dt
      return now
    },
    getDateTimeTh () {
      let date = new Date()
      date.setDate(date.getDate())
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var dt = date.getDate()

      const time = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
      if (dt < 10) {
        dt = '0' + dt
      }
      if (month < 10) {
        month = '0' + month
      }
      var now = year + '-' + month + '-' + dt + ' ' + time
      return now
    },
    getMonthTh () {
      let date = new Date()
      date.setDate(date.getDate())
      var month = date.getMonth() + 1
      var name = ''
      if (month === 1) {
        name = 'มกราคม'
      }

      switch (month) {
        case 1:
          name = 'มกราคม'
          break
        case 2:
          name = 'กุมภาพันธ์'
          break
        case 3:
          name = 'มีนาคม'
          break
        case 4:
          name = 'เมษายน'
          break
        case 5:
          name = 'พฤษภาคม'
          break
        case 6:
          name = 'มิถุนายน'
          break
        case 7:
          name = 'กรกฎาคม'
          break
        case 8:
          name = 'สิงหาคม'
          break
        case 9:
          name = 'กันยายน'
          break
        case 10:
          name = 'ตุลาคม'
          break
        case 11:
          name = 'พฤศจิกายน'
          break
        case 12:
          name = 'ธันวาคม'
          break

        default:
          break
      }
      return name
    },
    getMonthThToINT (month) {
      var dt = 0
      switch (month) {
        case 'มกราคม':
          dt = 1
          break
        case 'กุมภาพันธ์':
          dt = 2
          break
        case 'มีนาคม':
          dt = 3
          break
        case 'เมษายน':
          dt = 4
          break
        case 'พฤษภาคม':
          dt = 5
          break
        case 'มิถุนายน':
          dt = 6
          break
        case 'กรกฎาคม':
          dt = 7
          break
        case 'สิงหาคม':
          dt = 8
          break
        case 'กันยายน':
          dt = 9
          break
        case 'ตุลาคม':
          dt = 10
          break
        case 'พฤศจิกายน':
          dt = 11
          break
        case 'ธันวาคม':
          dt = 12
          break

        default:
          break
      }
      return dt
    },
    getMonthINTToTH (month) {
      var dt = ''
      switch (month) {
        case 1:
          dt = 'มกราคม'
          break
        case 2:
          dt = 'กุมภาพันธ์'
          break
        case 3:
          dt = 'มีนาคม'
          break
        case 4:
          dt = 'เมษายน'
          break
        case 5:
          dt = 'พฤษภาคม'
          break
        case 6:
          dt = 'มิถุนายน'
          break
        case 7:
          dt = 'กรกฎาคม'
          break
        case 8:
          dt = 'สิงหาคม'
          break
        case 9:
          dt = 'กันยายน'
          break
        case 10:
          dt = 'ตุลาคม'
          break
        case 11:
          dt = 'พฤศจิกายน'
          break
        case 12:
          dt = 'ธันวาคม'
          break

        default:
          break
      }
      return dt
    },
    getGetToken () {
      if (localStorage.getItem('data')) {
        this.dateExpire = localStorage.getItem('dateExpire')
        let date = this.getDateTh()
        if (date !== this.dateExpire) {
          localStorage.clear()
          this.$router.push('/Core/Login')
        }
      } else {
        localStorage.clear()
        this.$router.push('/Core/Login')
      }
    },
    getGetTokenForEmployee () {
      if (localStorage.getItem('data')) {
        this.dateExpire = localStorage.getItem('dateExpire')
        let date = this.getDateTh()
        if (date !== this.dateExpire) {
          localStorage.clear()
          this.$router.push('/Core/Login')
        }
      } else {
        localStorage.clear()
        this.$router.push('/Core/Login')
      }
    },
    getNowGlobal () {
      const today = new Date()
      // console.log(today)
      const date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate()
      const time =
        today.getHours() +
        ':' +
        today.getMinutes() +
        ':' +
        today.getSeconds() +
        ':' +
        today.getMilliseconds()
      const dateTime = date + ' ' + time
      return dateTime
    },
    generateCodeGlobal () {
      const today = new Date()
      // console.log(today)
      const code =
        today.getFullYear() +
        '' +
        (today.getMonth() + 1) +
        '' +
        today.getDate() +
        '' +
        today.getHours() +
        '' +
        today.getMinutes() +
        '' +
        today.getSeconds() +
        '' +
        today.getMilliseconds()
      return code
    },
    async getRunningCodeGlobal (DNS_IP, CODE) {
      var RUNCODE = ''
      const today = new Date()
      var DT = {
        runningCode: today.getFullYear() + '' + (today.getMonth() + 1) + '' + today.getDate() + '' + today.getHours() + '' + today.getMinutes() + '' + today.getSeconds() + '' + today.getMilliseconds(),
        runningName: CODE,
        runningYear: today.getFullYear(),
        runningMonth: (today.getMonth() + 1)
      }
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + '/system_running/' + "get?RECORD_STATUS=N&runningName=" + CODE +
          '&runningYear=' + today.getFullYear() +
          '&runningMonth=' + (today.getMonth() + 1), {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // console.log('getRunningCode', response.data[0])
          var rs = response.data[0]
          // console.log('Number;', rs.runningNumber)
          var number = Number(rs.runningNumber) + 1 // 1234
          // console.log('Convert : ', String(number))
          var str = String(number)
          var pad = '000'
          var ans = pad.substring(0, pad.length - str.length) + str
          // console.log('ANS : ', ans)
          //
          DT.runningNumber = ans
          //
          // console.log(DT)
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/system_running/' + "edit/" + rs.runningID,
              DT, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // console.log('Success', rs.runningName + '' + rs.runningYear + '' + rs.runningMonth + '' + ans)
              RUNCODE = rs.runningName + '' + rs.runningYear + '' + rs.runningMonth + '' + ans
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function system_running : ', error)
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(async (error) => {
          // console.log('ไม่พบข้อมูลให้เพิ่ม')
          //
          DT.runningNumber = '001'
          //
          console.log(JSON.stringify(DT))
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/system_running/' + "add",
              DT, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              RUNCODE = DT.runningName + '' + DT.runningYear + '' + DT.runningMonth + '' + DT.runningNumber
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function system_running : ', error)
            })
        })
      return RUNCODE
    },
    async getDataGlobal (DNS_IP, PATH) {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      this.dataItemImport = []
      // Clear ช่องค้นหา
      this.searchAll = ''

      console.log('Test Global')

      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "get", {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // var dateObj = new Date(response.data.CREATE_DATE)
          // var momentObj = moment(dateObj)
          // response.data.CREATE_DATE = momentObj.format('YYYY-MM-DD')
          // console.log('getData', response.data)
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataByIdGlobal (DNS_IP, PATH, FIELD_PK_NAME, id) {
      this.PK = id
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "getID?" + FIELD_PK_NAME + "=" + id, {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('get id : ', response)
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            delete this.formUpdate[FIELD_PK_NAME]
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['RECORD_STATUS']
            console.log('getDataById', this.formUpdate)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async addDataGlobal (DNS_IP, PATH, DT) {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "add",
              DT, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.getDataGlobal(DNS_IP, PATH)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editDataGlobal (DNS_IP, PATH, ID, DT) {
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "edit/" + ID,
              DT, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              await this.getDataGlobal(DNS_IP, PATH)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteDataGlobal (DNS_IP, PATH, ID) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "delete/" + ID,
              this.formUpdate, {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getDataGlobal(DNS_IP, PATH)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async searchDataAllGlobal (DNS_IP, PATH, DT) {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "find_advanced" + DT, {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // Clear Search All
          this.searchAll = ''
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function searchDataAllGlobal : ', error)
          this.clearSearch()
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
          this.getDataGlobal(DNS_IP, PATH)
        })
    },
    async saerchDataAdvancedGlobal (DNS_IP, PATH, DT) {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?RECORD_STATUS=N&" + DT, {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log(response.data)
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function saerchDataAdvancedGlobal : ', error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
          this.getDataGlobal(DNS_IP, PATH)
        })
    }
  }
})
Vue.component('my-currency-input', {
  props: ['value'],
  template: `
          <input type="text" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true"/>
     `,
  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface
          return this.value
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        }
      },
      set: function (modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        // eslint-disable-next-line no-useless-escape
        let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js